/** @jsx jsx */
import { jsx, Textarea } from 'theme-ui'

import styled from '@emotion/styled'

const StyledTextarea = styled(Textarea)`
  border: 1px solid #d1cdc5;
  background: #ffffff;
  box-sizing: border-box;
  color: #3b3a38;
  font-family: 'Avenir Next', Helvetica, Arial, sans-serifsystem-ui,
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue',
    sans-serif;
  line-height: 24px;
  font-size: 16px;
  font-weight: 400;
`

const CustomTextArea = ({ children, ...props }) => {
  return <StyledTextarea {...props}>{children}</StyledTextarea>
}

export default CustomTextArea
